export const LIST_ADD = 'LIST_ADD';
export const LIST_DELETE = 'LIST_DELETE';
export const FETCH_TRENDING = 'FETCH_TRENDING';
